<script setup lang="ts">
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<template>
  <div class="min-h-screen bg-gray-100 flex flex-col items-center justify-center px-4">
    <div class="text-center">
      <h1 class="text-9xl font-bold text-gray-800">
        404
      </h1>
      <p class="text-2xl font-semibold text-gray-600 mt-4">
        页面未找到
      </p>
      <p class="text-gray-500 mt-4 mb-8">
        抱歉，您访问的页面不存在或已被移除
      </p>
      <el-button
        type="primary"
        class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
        @click="router.replace('/')"
      >
        返回首页
      </el-button>
    </div>
  </div>
</template>
